import {useState,useEffect,useRef} from 'react'; 
import  Bredcrum  from '../../components/bredcrum';
import { Tag } from 'primereact/tag';
import {Tablescom} from '../../components/tablescomp';
import { Toast } from 'primereact/toast';
import {userservices} from '../../services/userServices';
import {productservices} from '../../services/productServices';
import { StockServices } from "../../services/stockServices";
import { supplierservices } from "../../services/supplierServices";
import {Titlebar,Searchbox,Label} from  '../../components/fieldsComp';
import {  useParams,useNavigate,useLocation   } from "react-router";
import { Formik, Field, Form } from "formik";
import {useSelector} from 'react-redux';
import {Loaderoverlay} from "../../components/loaderComp";
import {HandleClose} from '../../helpers/formclose';
const Editstock = () =>{

    const {id} = useParams();
    const location = useLocation();
    const unitreducer = useSelector((state)=>state.unitreducer);
    const currencyreducer = useSelector((state)=>state.currencyreducer);
    const [supllierlist,setSupllierlist] = useState([]);
    const [units,setUnits] = useState([]);
    const [users,setUsers] = useState([]);
    const [userloaded,setUserloaded] = useState(true);
    const toast = useRef(null);
    const [componentytpe, setComponenttype] = useState("product");
    const [components, setComponents] = useState([]);
    const [products, setProducts] = useState([]);
    const [currencies,setCurrencies] = useState([]);
    const [loading, setLoading] = useState(true);
    const [warehouses, setWarehouses] = useState([]);
    const navigate = useNavigate();


        useEffect(()=>{

            const fetchData = async () => {
                try {
                  setLoading(false); // show loader
                  await Promise.all([
                    getcomponents(),
                    getbulkproduct(),
                    getunits(),
                    getsupplier(),
                    getcurrency(),
                  ]);

                  let stocktype = location.state.stocktype;
                  setFormData({ stocktype });
                  setLoading(true);
                  console.log(location);
                } catch (error) {
                  console.error("Error fetching data:", error);
                } finally {
                  setLoading(true); // hide loader
                }
              };

              fetchData();
              getWarehouseDetails();

            // getcomponents();
            // getbulkproduct();
            // // getspecificproduct(id);
            // getunits();
            // let stocktype = location.state.stocktype;
            // // setComponenttype(stocktype);
            // setFormData({stocktype:stocktype});
            // getsupplier();
            // console.log(location);
            // getcurrency();
        },[]); 

        const [formData, setFormData] = useState({
            id:'',
            product_name: '',
            sku_code: '',
            stock_on_hand: '',
            stock_needed: '',
            discrepancy_alert: '', // boolean: can be true/false or 'true'/'false'
            restock_alert_threshold: '',
            stock_location: '',
            stock_type: '', // 'finished' or 'component'
        });
        

        const handleChange = (e) => {
            setFormData({
            ...formData,
            [e.target.name]: e.target.value,
            });
        };


        useEffect(() => {
            setComponenttype(formData.stocktype);
        }, [formData.stocktype]);

        const handleSave = (values) => {
            // console.log('Form Data:', values);
            // return;
            // Add your save logic here
            StockServices.editstock(values).then((response)=>{
                // console.log(response);
                 if(response.status == 200){
                    toast.current.show({ severity: 'success', summary: 'Stock', detail: `${response.data.data}` }); 
                    navigate(-1);
                 }else{
                    toast.current.show({ severity: 'error', summary: 'Stock', detail: `${response.data.data}` }); 
                 }   
            }).catch((error)=>{
                toast.current.show({ severity: 'error', summary: 'Stock', detail: 'Error' }); 
            });
        };

        const handleClose = () => {
            // Reset form or close modal logic
            console.log('Form Closed');
        };

function Componenttype(stocktype) {
    let component = <></>;
    let componentsdesign = [];
    components.forEach((value, index) => {
      componentsdesign.push(
        <option value={value.componentSkuCode}>{value.component}</option>
      );
    });

    let productsdesign = [];
    products.forEach((value, index) => {
      productsdesign.push(
        <option value={value.sku_code}>{value.product_name}</option>
      );
    });

    if (stocktype == "component") {
      component = (
        <Field
          as="select"
          name="product"
          className="form-control"
          placeholder="Select Component"
          required
        >
          <option value="">Select Component</option>
          {componentsdesign}
        </Field>
      );
    } else {
      component = (
        <Field
          as="select"
          name="product"
          className="form-control"
          placeholder="Select Product"
          required
        >
          <option value="">Select Product</option>
          {productsdesign}
        </Field>
      );
    }

    return component;
  }

  const getWarehouseDetails = () => {
      StockServices.getWorhouseData().then((response)=>{
        if(response.status == 200){
          setWarehouses(response.data.data);
        }else{
          setWarehouses([]);
        }
      }).catch((error) => {
        console.log("error: " , error);
      })
    }

  const displayWarehouseLocation = () =>{
  let items = [];
  warehouses.forEach((value, index) => {
    items.push(<option key={index} value={value.warehouse_code}>{value.name}</option>);
  })

  return items;
}
    


  const getspecificproduct  = (id)=> {
        // setUserloaded(false);
        productservices.getspecificproduct(id).then((response)=>{
            if(response.status == 200){
                setFormData(response.data.data);
            //   console.log(response.data.data);
            //     setUsers(response.data.data);
            //     setUserloaded(true);
            }else{
                // setUsers([]);
                // setUserloaded(true);
            }  
        }).catch((error)=>{
            // setUsers([]);
            // setUserloaded(true);
        }); 
  } 

  const getunits = () =>{
      unitreducer.then((response)=>{
          //  console.log(response);
           setUnits(response);
        }).catch((error)=>{
            
        });
    }
  
    const getsupplier = () =>{
        supplierservices.getallsupllier().then((response)=>{
          console.warn(response);
            if(response.status ==200){
                setSupllierlist(response.data.data);  
            }else{
                setSupllierlist([]); 
            }
             
          }).catch((error)=>{
                setSupllierlist([]); 
          });
      }

   function displaySupplier2(){
      let supllierdata = [];
      supllierlist.forEach((value,index)=>{
        supllierdata.push(<option value={value.id}>{value.name}</option>); 
      });
      return supllierdata;
   }

  function displayUnits(){
    let unitsarr = [];
    units.forEach((value,index)=>{
      unitsarr.push(<option value={value.short_code}>{value.name}</option>); 
    });

    return unitsarr;
  }

  const getbulkproduct = () => {
      productservices
        .getbulkproduct()
        .then((response) => {
          if (response.status == 200) {
            setProducts(response.data.data);
          } else {
            setProducts([]);
          }
        })
        .catch((error) => {
          setProducts([]);
        });
    };

  const getcomponents = () => {
    productservices
      .getcomponents()
      .then((response) => {
        if (response.status == 200) {
          setComponents(response.data.data);
        } else {
          setComponents([]);
        }
      })
      .catch((error) => {
        setComponents([]);
      });
  };

  function getCurrentDateTimeLocal() {
  const now = new Date();
  const offset = now.getTimezoneOffset();
  const localDate = new Date(now.getTime() - offset * 60000);
  return localDate.toISOString().slice(0, 16); // "YYYY-MM-DDTHH:MM"
}

const getcurrency = () => {
    currencyreducer.then((response)=>{
      
      // console.log("currency reducer");
      // console.log(response);
        setCurrencies(response);
      }).catch((error)=>{
    });
   } 

const displayCurrency = () => {
    let items = [];
    currencies.forEach((value,index)=>{
       items.push(<option key={index} value={value.code}>{value.code}</option>);
    })  
    return items;
  }
  
  return(
       <>
          <Toast ref={toast} /> 
          <Bredcrum title={'Stock / Update Stock'} divider={false}/>
         
          <div class="row">
              {/* <div className='col-md-12 mb-4 mt-4'>
                 <div className='flex-box flex-between'>
                      <button className='btn btn-primary rounded-pill custom-btn-color custom-btn-br-color custom-btn-style'>Add New Product</button> 
                      <Searchbox/>
                  </div> 
              </div>  */}
              <Loaderoverlay isloaded={loading}/>
              
              {/* <Titlebar text={'Edit Stock'}/> */}
              <div className="col-md-12 mt-3">
                  <div className='card ps-3 pe-3'>
                    <div className='card-body card-body-style'>
                         
                         <div className='row'>
                         <div className="container mt-4">
                          <Formik
                                    initialValues={location.state}
                                    onSubmit={async (values) => {
                                    handleSave(values);
                                    }}
                                >
                                    {({ handleChange, setFieldValue,values }) => (    
                
                                    <Form>
                                    <div className="row">
                                        <div className="col-md-6 form-group">
                                        <Label name="Stock Type" />
                                        <Field
                                            as="select"
                                            name="stocktype"
                                            className="form-control"
                                            placeholder="Stock Type"
                                            onChange={(e) => {
                                                setFormData({stocktype:e.target.value});
                                                setFieldValue("stocktype", e.target.value); // Update Formik state
                                            }}
                                        >
                                            <option value="">Select Stock type</option>
                                            <option value="component">Component</option>
                                            <option value="product">Product</option>
                                        </Field>
                                        </div>
                
                                        <div className="col-md-6 form-group">
                                        <Label name="Select Product" />
                                        {Componenttype(componentytpe)}
                                        </div>
                
                                        <div className="col-md-6 form-group">
                                        <Label name="Select Date" />
                                        <Field
                                            type="datetime-local"
                                            name="stock_date"
                                            className="form-control"
                                            placeholder="Select Date"
                                            required
                                        />
                                        </div>

                                        <div className="col-md-6 form-group">
                                          <Label name="Stock Type" />
                                          <Field
                                            as="select"
                                            name="stock_status"
                                            className="form-control"
                                            onChange={(e) => {
                                                setFieldValue("stock_status", e.target.value); // Update Formik state
                                            }}
                                          >

                                            <option value="">Select Stock Status</option>
                                            <option value="available">Available</option>
                                            <option value="used">Used</option>
                                            <option value="expired">Expired</option>
                                            <option value="damaged">Damaged</option>
                                          </Field>
                                        </div>
                
                                        <div className="col-md-6 form-group">
                                            <Label name="Batch Number" />
                                            <Field
                                            type="text"
                                            name="batch_number"
                                            className="form-control"
                                            placeholder="Enter Batch Number"
                                            required
                                            />
                                        </div>
                
                                        <div className="col-md-6 form-group">
                                        <Label name="Enter No of unit Produced" />
                                        <Field
                                            type="number"
                                            name="quantity"
                                            className="form-control"
                                            placeholder="Unit Produced"
                                            required
                                            onChange={(e) => {
                                                setFieldValue("quantity", e.target.value); // Update Formik state
                                                let total_cost = e.target.value * values.purchase_price; 
                                                setFieldValue('total_cost',total_cost);
                                                // console.log(values.batch_number);
                                            }}
                                        />
                                        </div>
                                        
                
                                        <div className="col-md-6 form-group">
                                            <Label name="Unit of Measurement" />
                                            <Field as="select"
                                                name="unit_of_measurement"
                                                className="form-control"
                                                required
                                            >
                                                <option value="">Select Unit of Measurement</option>
                                            {displayUnits()}
                                            </Field>
                                        </div>
                
                                        {/* Supplier ID */}
                                        <div className="col-md-6 form-group">
                                            <Label name="Supplier ID" />
                                            <Field
                                            as="select"
                                            name="supplier_id"
                                            className="form-control"
                                            placeholder="Enter Supplier ID"
                                            required
                                            >
                                                <option value="">Select Supplier</option>
                                            {displaySupplier2()}
                                            </Field>
                                        </div>
                                        <p className="pt-3 text-success">Manufacturing & Production Costs : </p>          
                                                                  <div className="row">
                                                                    {/* Fill Cost */}
                                                                    <div className="col-md-3 form-group">
                                                                      <Label
                                                                        name="Fill cost / Unit"
                                                                        classstyle="text-info"
                                                                        value="Fill Cost"
                                                                        mandate = {false}
                                                                        
                                                                      />
                                                                      <Field
                                                                        type="number"
                                                                        name="fill_cost"
                                                                        step="0.01"
                                                                        className="form-control"
                                                                        placeholder="Enter Fill Cost"
                                                                        onChange={(e) => {
                                                                          setFieldValue("fill_cost", e.target.value);
                                                                          // let total_cost =
                                                                          //   (e.target.value + values.co_pack_cost + values.manufacturing_service_charge + values.wastage_cost) * values.quantity;
                                                                          const fillCost = Number(e.target.value) || 0;
                                                                          let total_cost =
                                                                            fillCost +
                                                                            Number(values.co_pack_cost || 0) +
                                                                            Number(values.manufacturing_service_charge || 0) +
                                                                            Number(values.wastage_cost || 0);
                                                                            setFieldValue("purchase_price", total_cost * 1);
                                                                            total_cost = total_cost * values.quantity;  
                                          
                                                                            setFieldValue("total_cost", total_cost);
                                                                          
                                                                          // console.log(values.batch_number);
                                                                        }}
                                                                      />
                                                                    </div>
                                        
                                                                    {/* Co-Pack Cost */}
                                                                    <div className="col-md-3 form-group">
                                                                      <Label
                                                                        name="Co pack cost / unit"
                                                                        classstyle="text-info"
                                                                        value="Co-Pack Cost"
                                                                        mandate = {false}
                                                                      />
                                                                      <Field
                                                                        type="number"
                                                                        name="co_pack_cost"
                                                                        step="0.01"
                                                                        className="form-control"
                                                                        placeholder="Enter Co-Pack Cost"
                                                                        onChange={(e) => {
                                                                          setFieldValue("co_pack_cost", e.target.value);
                                                                          const co_pack_cost = Number(e.target.value) || 0;
                                                                          let total_cost =
                                                                            co_pack_cost +
                                                                            Number(values.fill_cost || 0) +
                                                                            Number(values.manufacturing_service_charge || 0) +
                                                                            Number(values.wastage_cost || 0);
                                                                            setFieldValue("purchase_price", total_cost * 1);
                                                                          total_cost = total_cost * values.quantity;  
                                          
                                                                          setFieldValue("total_cost", total_cost);
                                                                          
                                                                          // console.log(values.batch_number);
                                                                        }}
                                                                      />
                                                                    </div>
                                        
                                                                    {/* Manufacturing Service Charge */}
                                                                    <div className="col-md-3 form-group">
                                                                      <Label
                                                                        name="Manufacturing Service charge / Unit"
                                                                        classstyle="text-info"
                                                                        value="Manufacturing Service Charge"
                                                                        mandate = {false}
                                                                      />
                                                                      <Field
                                                                        type="number"
                                                                        name="manufacturing_service_charge"
                                                                        step="0.01"
                                                                        className="form-control"
                                                                        placeholder="Enter Manufacturing Service Charge"
                                                                        onChange={(e) => {
                                                                          setFieldValue("manufacturing_service_charge", e.target.value);
                                                                          const manufacturing_service_charge = Number(e.target.value) || 0;
                                                                          let total_cost =
                                                                            manufacturing_service_charge +
                                                                            Number(values.fill_cost || 0) +
                                                                            Number(values.co_pack_cost || 0) +
                                                                            Number(values.wastage_cost || 0);
                                                                            setFieldValue("purchase_price", total_cost * 1);
                                                                          total_cost = total_cost * values.quantity;  
                                          
                                                                          setFieldValue("total_cost", total_cost);
                                                                         
                                                                          // console.log(values.batch_number);
                                                                        }}
                                                                      />
                                                                    </div>
                                        
                                                                    {/* Wastage Cost */}
                                                                    <div className="col-md-3 form-group">
                                                                      <Label
                                                                        name="Wastage cost / Unit"
                                                                        classstyle="text-info"
                                                                        value="Wastage Cost"
                                                                        mandate = {false}
                                                                      />
                                                                      <Field
                                                                        type="number"
                                                                        name="wastage_cost"
                                                                        step="0.01"
                                                                        className="form-control"
                                                                        placeholder="Enter Wastage Cost"
                                                                        onChange={(e) => {
                                                                          setFieldValue("wastage_cost", e.target.value);
                                                                          const wastage_cost = Number(e.target.value) || 0;
                                                                          let total_cost = wastage_cost +
                                                                            Number(values.manufacturing_service_charge || 0) +
                                                                            Number(values.fill_cost || 0) +
                                                                            Number(values.co_pack_cost || 0);
                                                                            setFieldValue("purchase_price", total_cost * 1);
                                                                          total_cost = total_cost * values.quantity;  
                                          
                                                                          setFieldValue("total_cost", total_cost);
                                                                          
                                                                          
                                                                          // console.log(values.batch_number);
                                                                        }}
                                                                      />
                                                                    </div>
                                                                  </div>
                
                                        {/* Purchase Price */}
                                        <div className="col-md-6 form-group">
                                              <Label name="Per Unit Purchase Price" />
                                              <div className="flex-box">
                                                      <Field as="select" name="purchase_currency" className="form-control" style={{width:'100px'}} onChange={(e) => {
                                                            setFieldValue("purchase_currency", e.target.value); 
                                                            setFieldValue("totalcost_currency",e.target.value);
                                                            // Update Formik state
                                                        }}>
                                                              {displayCurrency()}
                                                      </Field>   
                                                      <Field
                                                          type="number"
                                                          name="purchase_price"
                                                          step="0.01"
                                                          className="form-control"
                                                          placeholder="Enter Purchase Price"
                                                          onChange={(e) => {
                                                              setFieldValue("purchase_price", e.target.value); // Update Formik state
                                                              let total_cost = e.target.value * values.quantity; 
                                                              setFieldValue('total_cost',total_cost.toFixed(2));
                                                            }}
                                                          />   
                                                    
                                              </div>    
                                          </div>
                
                                        {/* Total Cost */}
                                        <div className="col-md-6 form-group">
                                            <Label name="Total Cost" />
                                            <div className="flex-box">
                                              <Field as="select" name="totalcost_currency" className="form-control" style={{width:'100px'}}>
                                                  {displayCurrency()}
                                              </Field>   
                                          
                                              <Field
                                                type="number"
                                                name="total_cost"
                                                step="0.01"
                                                className="form-control"
                                                placeholder="Enter Total Cost"
                                                disableds
                                                />   
                                            </div>                 
                                        </div>
                
                                        {/* Expiry Date */}
                                        <div className="col-md-6 form-group">
                                            <Label name="Expiry Date (Optional)" mandate={false}/>
                                            <Field
                                            type="date"
                                            name="expiry_date"
                                            className="form-control"
                                            placeholder="Select Expiry Date"
                                            />
                                        </div>
                
                                        {/* Warehouse Location */}
                                        {/* <div className="col-md-6 form-group">
                                            <Label name="Warehouse Location" />
                                            <Field
                                            type="text"
                                            name="warehouse_location"
                                            className="form-control"
                                            placeholder="Enter Warehouse Location"
                                            />
                                        </div> */}

                                        <div className="col-md-6 form-group">
                                              <Label name="Warehouse Location" />
                                              {/* <Field
                                              type="text"
                                              name="warehouse_location"
                                              className="form-control"
                                              placeholder="Enter Warehouse Location"
                                              /> */}
                                              <Field as="select" name="warehouse_location" className="form-control" onChange={(e) => {
                                                  setFieldValue('warehouse_location',e.target.value);
                                              }} >
                                                  <option value="">Select Warehouse</option>
                                                  {displayWarehouseLocation()}
                                              </Field>   
                                          </div>
                
                                        {/* Notes */}
                                        <div className="col-md-12 form-group">
                                            <Label name="Notes" />
                                            <Field
                                            as="textarea"
                                            name="notes"
                                            className="form-control"
                                            placeholder="Enter Notes"
                                            />
                                        </div>
                                    </div>
                
                                    <br></br>
                                    {/* <br></br> */}
                                    <div className="row">
                                        <div className="col-md-6">
                                        <button
                                            type="submit"
                                            className="btn color-white me-2 w-100 rounded custom-btn-br-color custom-btn-color"
                                        >
                                            Save
                                        </button>
                                        </div>
                
                                       {<HandleClose/>}
                                    </div>
                                    </Form>)}
                                </Formik>

                                </div>
                            </div>
                     </div>
                 </div>
              </div>   
          </div>
       </>
    );   
 }
 export default Editstock;